import styled from 'styled-components';

export const ImageViewerContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-color: #000;
  position: relative;
  overflow-x: hidden;
`;

export const SidebarContainer = styled.div`
  width: 300px;
  height: 100%;
  background-color: #1a1a1a;
  border-right: 2px solid #333;
  overflow-y: auto;
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    position: fixed;
    top: 50px;
    left: 0;
    z-index: 999;
    height: calc(100vh - 50px);
  }
  
  .exam-list {
    height: 100%;
    padding: 0;
  }
  
  .series-grid {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;

export const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  transition: margin-left 0.3s ease-in-out;

  @media (max-width: 768px) {
    margin-left: ${({ isMenuOpen }) => (isMenuOpen ? '300px' : '0')};
    width: 100%;
    padding-top: 50px;
  }
`;

export const ViewerHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: #1a1a1a;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 5px;
  
  &:hover {
    opacity: 0.8;
  }
`;

export const BackIcon = styled.span`
  margin-right: 5px;
  display: inline-block;
  width: 24px;
  height: 24px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='white' viewBox='0 0 24 24'%3E%3Cpath d='M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z'/%3E%3C/svg%3E");
`;

export const DicomImageContainer = styled.div`
  flex: 1;
  position: relative;
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 100px); /* Adjust based on header height */
  overflow: hidden;
  width: 100%;
`;

export const CornerstoneImage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000;
  
  canvas {
    max-width: 100%;
    max-height: 100%;
    width: auto !important;
    height: auto !important;
    background-color: #000 !important;
    object-fit: contain;
  }
`;

export const ControlsContainer = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
`;

export const ImageInfoLabel = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 10px 14px;
  border-radius: 6px;
  font-size: 24px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  z-index: 1;

  .info-row {
    display: flex;
    align-items: center;
    gap: 6px;

    &:first-child {
      .label, .value {
        color: rgba(255, 99, 71, 0.9); /* Soft red for Im: row */
      }
    }

    &:last-child {
      .label, .value {
        color: rgba(255, 215, 0, 0.9); /* Soft yellow for Ser: row */
      }
    }
  }

  .label {
    opacity: 0.8;
  }

  .value {
    font-weight: 500;
  }
`;
